import { Component, OnInit } from '@angular/core';
import { Subscription, of } from 'rxjs';

import { QuestionarioService } from 'src/app/services/questionario.service';
import { StepService } from 'src/app/services/step.service';
import domande from 'src/assets/domande.json';
import { ApiService } from 'src/services/api.service';

@Component({
  selector: 'app-question',
  templateUrl: './question.component.html',
  styleUrls: ['./question.component.scss'],
})
export class QuestionComponent implements OnInit {
  constructor(
    private step: StepService,
    private api: ApiService,
    private questionarioService: QuestionarioService
  ) {}

  checked = false;
  check: any = [];
  id: string = '0';
  idCheckati: string[] = [];
  selectedAnswer: string = '';
  text: string = '';
  width: string = '0%';
  variable: any;
  incr: any;

  questionario: any;
  surveyId: string = '';
  token: string = '';
  private subscription = new Subscription();
  ngOnInit(): void {
    this.subscription = this.step
      .getShowRingraziamenti()
      .subscribe((showRingraziamenti) => {
        this.showRingraziamenti = showRingraziamenti;
      });
    this.subscription = this.questionarioService
      .getQuestionario()
      .subscribe((questionario) => {
        StepService.totalQuestion = questionario.length;
        this.questionario = questionario;
        this.variable = questionario.length;
        this.surveyId = questionario[0].surveyId;
        this.token = questionario[0].token;
        this.incr = 100 / this.variable;
        if (
          this.questionario[this.currentQuestionIndex]?.answerValue &&
          this.questionario[this.currentQuestionIndex]?.questionType === 'open'
        ) {
          this.text = this.questionario[this.currentQuestionIndex].answerValue;
        } else {
          this.text = '';
        }
        if (
          this.questionario[this.currentQuestionIndex]?.answerValue &&
          this.questionario[this.currentQuestionIndex]?.questionType === 'range'
        ) {
          this.selectedAnswer =
            this.questionario[this.currentQuestionIndex].answerValue;
        } else {
          this.selectedAnswer = '';
        }
      });
    this.subscription = this.step
      .getShowRiepilogo()
      .subscribe((showRiepilogo) => {
        this.showRiepilogo = showRiepilogo;
        if (this.showRiepilogo === true) {
          this.questionarioService.getSurveyByToken(this.token);
        }
      });
    this.subscription = this.step.getWidth().subscribe((width) => {
      this.width = width;
    });
  }

  onCheckboxChange(answer: string) {
    this.selectedAnswer = answer;
  }

  log() {
    console.log(this.text);
  }

  currentQuestionIndex = 0;

  nextClicked = false;
  prevClicked = false;

  animationCompleted = false;
  direction: 'up' | 'down' | null = null;
  showRiepilogo = false;
  showRingraziamenti = false;
  domandeSelezionate: any[] = [];

  currentQuestion: any; // Declare the currentQuestion property

  sendAnswers() {
    this.step.setShowRingraziamenti(true);
  }

  nextQuestion() {
    if (this.questionario[this.currentQuestionIndex]?.questionType === 'open') {
      this.questionario[this.currentQuestionIndex].answerValue = this.text;
    }

    if (
      this.questionario[this.currentQuestionIndex]?.questionType === 'range'
    ) {
      this.questionario[this.currentQuestionIndex].answerValue =
        this.selectedAnswer;
    }

    this.direction = 'up';
    // this.currentQuestion = this.questions[this.currentQuestionIndex];
    this.currentQuestion =
      this.currentQuestionIndex < this.questionario.length
        ? this.questionario[this.currentQuestionIndex]
        : null;
    // Create a copy of the current question
    let copiedQuestion = JSON.parse(JSON.stringify(this.currentQuestion));

    // Filter the answers to only include the selected ones
    copiedQuestion.questionTypeValues =
      copiedQuestion.questionTypeValues.filter((risposta: any) =>
        this.selectedAnswer.includes(
          `${this.currentQuestion.id}_${risposta.id}`
        )
      );

    // Check if any answer does not have a tag

    copiedQuestion.questionTypeValues.forEach(
      (risposta: any, index: number) => {
        if (!risposta) {
          // If the answer does not exist, create a new one with the textarea value
          copiedQuestion.risposte[index] = {
            id: (index + 1).toString(),
            risposta: this.text,
          };
        } else if (!risposta.tag) {
          // If the answer exists but does not have a tag, assign the textarea value
          risposta.risposta = this.text;
        }
      }
    );

    // Add the copied question with the selected answers to the domandeSelezionate array
    this.domandeSelezionate.push(copiedQuestion);
    if (this.currentQuestionIndex === this.questionario.length - 1) {
      this.showRiepilogo = true;
      console.log('sono io');
    }

    if (this.currentQuestionIndex < this.questionario.length) {
      this.currentQuestionIndex++;
    }

    // const wi = (parseFloat(this.width) + this.incr).toString() + '%';
    // this.step.setWidth(wi);

    // if (this.showRiepilogo) {
    //   this.step.setWidth('100%');
    // }
    let dataToSend = {
      answer: this.text !== '' ? this.text : this.selectedAnswer,
    };

    this.api.put(`/squestions/${this.surveyId}/answer`, dataToSend).subscribe({
      next: (value) => {
        StepService.currentQuestion = this.currentQuestionIndex;
      },
      complete: () => {
        if (
          this.questionario[this.currentQuestionIndex]?.answerValue &&
          this.questionario[this.currentQuestionIndex]?.questionType === 'open'
        ) {
          this.text = this.questionario[this.currentQuestionIndex].answerValue;
        } else {
          this.text = '';
        }
        if (
          this.questionario[this.currentQuestionIndex]?.answerValue &&
          this.questionario[this.currentQuestionIndex]?.questionType === 'range'
        ) {
          this.selectedAnswer =
            this.questionario[this.currentQuestionIndex].answerValue;
        } else {
          this.selectedAnswer = '';
        }
      },
      error: (err) => {
        console.log('ERRORE', err);
      },
    });
  }

  setSurveyId(surveyId: string) {
    this.surveyId = surveyId;
  }
  previousQuestion() {
    if (this.currentQuestionIndex > 0) {
      this.direction = 'down';

      this.currentQuestionIndex--;
    }
    if (this.width !== '0%') {
      const wi = (parseFloat(this.width) - this.incr).toString() + '%';
      this.step.setWidth(wi);
    }
    if (
      this.questionario[this.currentQuestionIndex]?.answerValue &&
      this.questionario[this.currentQuestionIndex]?.questionType === 'open'
    ) {
      this.text = this.questionario[this.currentQuestionIndex].answerValue;
    } else {
      this.text = '';
    }
    if (
      this.questionario[this.currentQuestionIndex]?.answerValue &&
      this.questionario[this.currentQuestionIndex]?.questionType === 'range'
    ) {
      this.selectedAnswer =
        this.questionario[this.currentQuestionIndex].answerValue;
    } else {
      this.selectedAnswer = '';
    }
    StepService.currentQuestion = this.currentQuestionIndex;
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
